import React, { useCallback, useMemo } from 'react';
import { Subscription, SubscriptionStatus } from 'api/billing/types';
import { queryClient } from 'queries';
import { ACCOUNT_META_DATA_QUERY_KEY } from 'queries/account';
import {
  SUBSCRIPTION_KEY,
  useForceSyncSubscriptionMutation,
} from 'queries/billing';
import { BillingCheckout } from './checkout';
import { getPlanName } from './utils';

interface Props {
  subscription: Subscription;
  onDismiss: () => void;
}

export const BillingReactivate = ({ subscription, onDismiss }: Props) => {
  const { mutateAsync: forceSyncSubscription } =
    useForceSyncSubscriptionMutation();

  const onUpgradeSuccess = useCallback(async () => {
    await forceSyncSubscription(subscription.subscriptionId);
    await queryClient.invalidateQueries(SUBSCRIPTION_KEY);
    await queryClient.invalidateQueries(ACCOUNT_META_DATA_QUERY_KEY);
  }, [forceSyncSubscription, subscription.subscriptionId]);

  const isCanceled = useMemo(
    () => subscription.subscriptionStatus === SubscriptionStatus.CANCELLED,
    [subscription.subscriptionStatus],
  );

  const changePlanParams = useMemo(
    () => ({
      plan: getPlanName(subscription.plan.planName),
      subscription,
      isReactivation: true,
    }),
    [subscription],
  );

  return (
    <>
      {isCanceled && (
        <BillingCheckout
          changePlanParams={changePlanParams}
          onSuccess={onUpgradeSuccess}
          onDismiss={onDismiss}
        />
      )}
    </>
  );
};
